import { POST } from "../APiHelper/API"
let source;
export const getTeamStatsAPI = (season_id, team_id, onSuccess, onError) => {
    const data = {
        season_id: season_id,
        team_id: team_id
    }

    source = POST(`/api/v1/players_stats/team`, data, onSuccess, onError, true, source)
}